define([
    'vue',
    'common/toast/loading'
], function(
    Vue,
    LoadingToast
){
    return new Vue({
        el: '#toast-overlay',
        components: {
            LoadingToast: LoadingToast
        },
        data: {
            loadingToast: {
                isShow: false
            }
        },
        methods: {
            showLoadingToast: function(){
                this.loadingToast.isShow = true;
            },
            hideLoadingToast: function(){
                this.loadingToast.isShow = false;
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./common/toast/toast.js
// module id = 94
// module chunks = 0 1 2 3